import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { ConcreteTestSets } from '../../../cimsPage/instances/concrete'

const page = ConcreteTestSets

export const EditConcreteBreakData = new BasicPermissionItem({
  id: '7B326C2D-9809-4592-8804-BBC03D3B655F',
  name: 'Edit Concrete Break Data',
  action: 'create, edit, and remove concrete break data',
  page,
})

/** Only read because this is a Mobile App Table */
export const ViewConcreteTestSet = Simple({
  id: 'F130C9ED-9EF6-4EE4-8322-441A08515676',
  action: 'View',
  object: 'Concrete Test Set',
  page,
})

export const EditAssociatedDocumentChecklistItem = new BasicPermissionItem({
  id: 'BF11FDC1-3570-41A4-BA6D-2C8B0092F7F8',
  name: 'Edit Associated Document Checklist Item',
  action: "check or uncheck a concrete test set's document checklist items",
  page,
})

/** Does not necessarily give you access to PDF Reports */
export const CreateConcretePacket = Simple({
  id: '7BD30638-CC80-4645-97AC-8DEFBECDCADA',
  action: 'Create',
  object: 'Concrete Packet',
  page,
})

const object = 'Concrete Packet File'

export const UploadConcretePacketFile = new BasicPermissionItem({
  id: 'CC4A9DC3-FBC1-43EF-A982-C1D23C63103D',
  action: `upload ${object}s`,
  name: `Upload ${object}`,
  page,
})

export const ViewConcretePacketFile = Simple({
  id: 'E79E25DF-348A-4983-ADDA-2F3A895D8078',
  action: 'View',
  object,
  page,
})

export const RemoveConcretePacketFile = Simple({
  id: 'F7E0D77C-F5A2-4DEE-ADE7-E17B6A386580',
  action: 'Remove',
  object,
  page,
})

export type ConcreteTrackerPermission =
  | typeof EditConcreteBreakData
  | typeof ViewConcreteTestSet
  | typeof EditAssociatedDocumentChecklistItem
  | typeof CreateConcretePacket
  | typeof UploadConcretePacketFile
  | typeof ViewConcretePacketFile
  | typeof RemoveConcretePacketFile
